module.exports = __webpack_public_path__ + "img/head.9a3daa6e.svg";